import Eyeoff from './Eyeoff';
import Eyeon from './Eyeon';
import RightArrow from './RightArrow';
import ChevronDown from './ChevronDown';
import Down from './Down';
import Calendar from './Calendar';
import LeftArrow from './LeftArrow';
import User from './User';
import Download from './Download';
import CloseIcon from './CloseIcon';
import EditIcon from './EditIcon';

export const ICON_TYPES = {
  EYEOFF: 'eye-off',
  EYEON: 'eye-on',
  RIGHTARROW: 'right-arrow',
  CHEVRONDOWN: 'chevron-down',
  DOWN: 'down',
  CALENDAR: 'calendar',
  LEFTARROW: 'left-arrow',
  USER: 'user',
  DOWNLOAD: 'download',
  CLOSEICON: 'close-icon',
  EDITICON: 'edit-icon',
};

export const ICON_NAME_VS_CMP = {
  [ICON_TYPES.EYEOFF]: Eyeoff,
  [ICON_TYPES.EYEON]: Eyeon,
  [ICON_TYPES.RIGHTARROW]: RightArrow,
  [ICON_TYPES.CHEVRONDOWN]: ChevronDown,
  [ICON_TYPES.DOWN]: Down,
  [ICON_TYPES.CALENDAR]: Calendar,
  [ICON_TYPES.LEFTARROW]: LeftArrow,
  [ICON_TYPES.USER]: User,
  [ICON_TYPES.DOWNLOAD]: Download,
  [ICON_TYPES.CLOSEICON]: CloseIcon,
  [ICON_TYPES.EDITICON]: EditIcon,
};
